import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { useAuthStore } from 'Store/Auth'
import { useAuthSessionStore } from 'Store/AuthSession'
import mainAxios from 'axios'
import { Cookies } from 'react-cookie'
import { toast } from 'react-toastify'

export function setupAxios(axios: any) {
	axios.defaults.baseURL = process.env.REACT_APP_API_URL
	axios.defaults.headers.Accept = 'application/json'

	axios.interceptors.request.use(
		(config: AxiosRequestConfig) => {
			const accessToken = new Cookies().get('kumopack-supplier-access-token')
			const sessionAccessToken = useAuthSessionStore.getState().accessToken

			if (accessToken || sessionAccessToken) {
				// @ts-ignore
				config.headers.Authorization = `Bearer ${accessToken ? accessToken : sessionAccessToken}`
			}
			return config
		},
		async (error: any) => {
			return Promise.reject(error)
		}
	)

	axios.interceptors.response.use(
		(response: AxiosResponse) => {
			return response
		},
		async (error: any) => {
			const originalRequest = error.config

			// if (originalRequest?.url === '/suppliers/profile') {
			// 	new Cookies().remove('kumopack-supplier-access-token', {
			// 		domain: process.env.NODE_ENV === 'production' ? '.kumopack.com' : undefined,
			// 		path: '/',
			// 	})
			// 	new Cookies().remove('kumopack-supplier-refresh-token', {
			// 		domain: process.env.NODE_ENV === 'production' ? '.kumopack.com' : undefined,
			// 		path: '/',
			// 	})
			// }

			if (
				error?.response?.data?.message === 'ผู้ใช้งานนี้ถูกลบแล้ว' ||
				error?.response?.data?.message === 'ไม่พบผู้ใช้งานนี้ในระบบ'
			) {
				toast.error('ผู้ใช้งานของคุณถูกลบแล้ว', {
					position: 'top-right',
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})

				useAuthStore.getState().clearState()
				useAuthSessionStore.getState().clearState()
			}

			if (error?.response?.status === 401 && !originalRequest?._retry) {
				if (originalRequest.url.includes('/auth-supplier/refresh-token')) {
					const cookies = new Cookies()
					cookies.remove('kumopack-supplier-access-token', {
						domain: process.env.NODE_ENV === 'production' ? '.kumopack.com' : undefined,
						path: '/',
					})
					cookies.remove('kumopack-supplier-refresh-token', {
						domain: process.env.NODE_ENV === 'production' ? '.kumopack.com' : undefined,
						path: '/',
					})

					// Handle logout or token cleanup here
					return Promise.reject(error)
				}

				originalRequest._retry = true
				const refreshToken = new Cookies().get('kumopack-supplier-refresh-token')
				let isError = false
				let request: Promise<any> = Promise.resolve()

				if (refreshToken) {
					try {
						const response = await mainAxios.post(
							`${process.env.REACT_APP_API_URL}/auth-supplier/refresh-token`,
							undefined,
							{
								headers: {
									Authorization: `Bearer ${refreshToken}`,
								},
							}
						)
						const { accessToken } = response.data

						const cookies = new Cookies()
						cookies.remove('kumopack-supplier-access-token', {
							domain: process.env.NODE_ENV === 'production' ? '.kumopack.com' : undefined,
							path: '/',
						})
						cookies.set('kumopack-supplier-access-token', accessToken, {
							domain: process.env.NODE_ENV === 'production' ? '.kumopack.com' : undefined,
							path: '/',
						})

						axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken

						request = axios.request(originalRequest)
					} catch (err: any) {
						isError = true
					}

					if (isError) {
						const cookies = new Cookies()
						cookies.remove('kumopack-supplier-access-token', {
							domain: process.env.NODE_ENV === 'production' ? '.kumopack.com' : undefined,
							path: '/',
						})
						cookies.remove('kumopack-supplier-refresh-token', {
							domain: process.env.NODE_ENV === 'production' ? '.kumopack.com' : undefined,
							path: '/',
						})

						return Promise.reject(error)
					}

					return Promise.resolve(request)
				} else {
					useAuthStore.getState().clearState()
					useAuthSessionStore.getState().clearState()
				}
			} else if (JSON.parse(JSON.stringify(error))?.status === null) {
				toast.error('ไม่สามารถเชื่อมต่อกับระบบได้', {
					position: 'top-right',
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
				// Swal.fire({
				// 	title: 'ไม่สามารถเชื่อมต่อกับระบบได้',
				// 	text: 'กรุณาลองใหม่อีกครั้ง หรือติดต่อผู้ดูแลระบบ',
				// 	icon: 'error',
				// 	customClass: {
				// 		confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
				// 	},
				// 	confirmButtonText: 'ตกลง',
				// })
			}

			return Promise.reject(error)
		}
	)
}
